module.exports = __webpack_public_path__ + "static/media/mito22.9ec51bd6.jpg";